.icon {
  flex-shrink: 0;
  stroke: var(--icon-color, var(--theme-text-primary-default));
}

.icon.filled {
  stroke: none;
  fill: var(--icon-color, var(--theme-text-primary-default));
}
